// extracted by mini-css-extract-plugin
module.exports = {"o1oxpglm":"o1oxpglm"};